import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router, RouterLink } from '@angular/router';
import { TextInputDataComponent } from '../../../components/text-input/text-input.component';
import { SelectComponent } from '../../../components/select/select.component';
import { HandleBookingService } from '../../../services/handle-booking.service';
import { RadioBtnComponent } from '../../../components/radio-btn/radio-btn.component';
import { ParkingRepo } from '../../../repo/parking.repo';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { EmailInputFieldComponent } from '../../../components/email-input-field/email-input-field.component';
import { PhoneNumberInputComponent } from '../../../components/phone-number-input/phone-number-input.component';
import { AsyncPipe, CommonModule } from '@angular/common';
import { FormService } from '../../../organizations/features/booking/components/form/service';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { BookingSummaryCardComponent } from '../../../components/booking-summary-card/booking-summary-card.component';
import { BookingConfigService } from '../../../services/booking-config.service';
import { FormGroup, FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BASE64_FLYGETS_LOGO } from '../../../../../assets/base64-logos/flygets-logo';
import { BASE64_SKAVSTA_LOGO } from '../../../../../assets/base64-logos/skavsta-logo';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { BackOfficeService } from '../../../../services/backoffice.service';
import { DatePickerModalComponent } from '../../../components/datepicker-modal/datepicker-modal.component';
import { FlightPickerModalComponent } from '../../../../../app/parkifly-bookings/flightpicker-modal/flightpicker-modal.component';
import { ModalSimpleDatetimeComponent } from '../../../components/modal-simple-datetime/modal-simple-datetime.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, catchError, map, of, throwError, timeout } from 'rxjs';
import { CartService } from '../../../../../app/services/cart.service';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateAttributePipe } from '../../../../../app/pipes/translate-attribute/translate-attribute.pipe';
import { AdditionalServicesComponent } from '../additional-services/edit-booking-additional-services.component';
import { CheckboxComponent } from '../../../components/checkbox/checkbox.component';
import { CartService as Cart } from '../../../../../app/parkifly-bookings/services/cart.service';
import { TermsAndConditionsComponent } from '../terms-and-conditions/terms-and-conditions.component';

@Component({
  selector: 'app-update-booking',
  imports: [
    RouterLink,
    TextInputDataComponent,
    SelectComponent,
    RadioBtnComponent,
    TranslocoModule,
    EmailInputFieldComponent,
    PhoneNumberInputComponent,
    CommonModule,
    BookingSummaryCardComponent,
    MatProgressBarModule,
    MatListModule,
    MatIconModule,
    MatFormFieldModule,
    MatButtonModule,
    MatLabel,
    MatCheckboxModule,
    AdditionalServicesComponent,
    TranslateAttributePipe,
    CheckboxComponent,
    FormsModule,
    AsyncPipe
  ],
  templateUrl: './update-booking.component.html',
  styleUrl: './update-booking.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [HandleBookingService]
})

export class UpdateBookingComponent {
  handleBookingStatus: 'error' | 'updated' | '' = '';
  handleBookingGroup: any;
  email: string | null = "";
  bookingNumber: string | null = "";
  arrivalParkingOptions = [
    { value: '', viewValue: '' },
  ];
  parkingFrom: any;
  site: string = ""
  booking: any = null;
  checkInBagage: any = []
  additionalServices: any;
  orderId: any = null;
  passengers = [
    { value: '1', viewValue: '1' },
    { value: '2', viewValue: '2' },
    { value: '3', viewValue: '3' },
    { value: '4', viewValue: '4' },
    { value: '5', viewValue: '5' },
    { value: '6', viewValue: '6' },
    { value: '7', viewValue: '7' },
    { value: '8', viewValue: '8' },
  ]
  parkType: string = '';
  freeShuttles: boolean = false;
  bookingDetails: any = {
    order: null,
    parking: null,
    shuttles: [],
    additionalServices: []
  };
  form !: FormService;
  details !: FormGroup;
  parkingGroup: any;
  departureHotel: any;
  arrivalHotel: any;
  bookingLoaded: boolean = false;
  activeLang: string = 'sv';
  officeAddress: string = 'Matchedin AB, org.nr: 559013-7716 Wallingatan 42, 111 24 Stockholm';
  isLoading: boolean = false;
  parkingNames: any = {
    "677844ae-bb01-4265-bfde-32264410ed09": 'P_49',
    "453f945a-ee11-4d75-8265-b16f00e5f04b": 'P_41',
    "f9e5d6c3-4419-4c61-a290-b16f00e5e500": 'P_40',
    "8c98315a-b2ad-4e70-86f9-5d54992fed26": 'P_39',
    "697844ae-bb01-4265-bfde-32264410ed09": 'P_67',
    "c797769e-66bf-4283-96c5-b16f00e5e126": 'P_1',
    "eacc8615-81a4-4013-a7e5-b16f00e5e270": 'P_6',
    "1a8879f4-a294-455b-97eb-b16f00e5e30a": 'P_12',
    "5d2c7728-6944-45a6-a64e-b16f00e5e3b3": 'P_18',
    "8d922482-7855-47dc-953b-b16f00e5e45a": 'P_24'
  }
  base64FlygetsLogo = BASE64_FLYGETS_LOGO;
  base64SkavstaLogo = BASE64_SKAVSTA_LOGO;
  organizationId: string = 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';
  allAdditionalServices: any = [];
  isEditable: boolean = false;
  formHasChanges = false;
  isInitializing = true;
  originalBookingDetails: any = null;
  advancedBooking: boolean = true;
  showDepHotel: boolean = false;
  showArrHotel: boolean = false;
  arriveAtParkingOptions: any = [];
  hotelOptions: any = [];
  timeOptions: any = [];
  isLoadingParkings: boolean = false;
  parkings: any;
  selectedParking = new BehaviorSubject<any>(null);
  showRetryButton = false;
  lastApiParams: { periodFrom: string, periodTo: string, discountCode: string } | null = null;
  tentantConfigSortingParking: any = {
    'skavsta': (parkings: any[]) => {
      []
      if (parkings?.length > 1) {
        const firstItem = parkings.shift();
        parkings.push(firstItem);
      }
      return parkings;
    }
  };
  departureFlight: any;
  arrivalFlight: any;
  orgId: any = '';
  additionalServicesFromOrder: any = null;
  formattedDeparture: string = '';
  formattedArrival: string = '';
  fieldSubscriptions: any[] = [];
  previousPrice: number = 0;
  currentPrice: number = 0;
  showPriceComparison: boolean = false;
  showPaymentButton: boolean = false;
  consent: boolean = false;
  additionalPaymentAmount: number = 0;
  hasSpecialParams: boolean = false;
  parkingOutOfOrder: boolean = false;

  get isParkingUnavailable(): boolean {
    if (this.parkingOutOfOrder) {
      return true;
    }
    const parking = this.selectedParking.value;
    return parking != null && (parking.availableParkingSpots <= 0 && (this.booking?.parkingStatus !== 'Checkin'));
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private handleBookingService: HandleBookingService,
    private parkingRepo: ParkingRepo,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private translocoService: TranslocoService,
    private cart: Cart,
    private bookingConfigService: BookingConfigService,
    private _formService: FormService,
    public backofficeService: BackOfficeService,
    public translate: TranslocoService,
    public http: HttpClient,
    private cartService: CartService,
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
  }

  public ngOnInit() {
    this.generateTimeOptions();
    this.isLoading = true;
    this.getPreservedQueryParams();
    this.activeLang = this.translocoService.getActiveLang();
    this.translocoService.langChanges$.subscribe((lang) => {
      this.activeLang = lang;
    });
    this.translocoService.selectTranslate('PARKIFLY.PLACEHOLDER.1_HOUR_BEFORE')
      .subscribe(value => {
        this.checkInBagage = [
          { value: '1', viewValue: this.translocoService.translate("PARKIFLYFORM.YES") },
          { value: '0', viewValue: this.translocoService.translate("PARKIFLY.SUMMARY.ONLY_CARRYON_LUGGAGE_OPTION") },
        ]
      });

    this.route.paramMap.subscribe(params => {
      this.email = params.get("email");
      this.bookingNumber = params.get("booking_number");
      if (this.email && this.bookingNumber) {
        this.handleBookingService.getBookingDetails(this.email, this.bookingNumber).subscribe(
          {
            next: ((bookingDetails) => {
              if (bookingDetails?.orderStatus == "Checkout" || bookingDetails?.orderStatus == "CheckoutAdditional" || bookingDetails?.parkingStatus == "Checkout") {
                this.routerNavigatePreservingParams(['/parkifly/booking-overview', { email: this.email, booking_number: this.bookingNumber }]);
              }

              this.site = bookingDetails.organizationName?.toLowerCase();
              if (this.site == "flygets.se") {
                this.site = "flygets";
              }
              if (this.site == "tui" || this.site == "nazar" || this.site == "ving") {
                this.site = "flygets";
              }
              if (this.site == "quality hotel arlanda xpo parkering" || this.site == "quality-xpo-arlanda" || this.site == "quality") {
                this.site = "quality-xpo-arlanda";
              }
              if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.site = "aiden";
              }

              if (this.site == "skavsta" || this.site == "quality hotel arlanda xpo parkering" || this.site == "quality-xpo-arlanda" || this.site == "quality" || this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.advancedBooking = false;
              } else {
                this.advancedBooking = true;
                this.getHotelSelectOptions().subscribe({
                  next: (hotelOptions: any) => {
                    hotelOptions.map((option: any) => {
                      this.hotelOptions.push({ value: option.terminalName, viewValue: option.terminalName })
                    })
                  }
                });
              }

              this.bookingConfigService.setOrganization(this.site);
              this.handleBookingService.initForm(this.site);
              this._formService.initForm(this.site);
              this.handleBookingGroup = this.handleBookingService.getForm().get('details');

              setTimeout(() => {
                this.isInitializing = false;
              }, 1000);

              this.handleBookingGroup.valueChanges.subscribe(() => {
                if (!this.isInitializing) {
                  this.checkFormChanges();
                }
              });

              this.form = this._formService;
              this.details = this.form.getForm().get('details');
              this.parkingGroup = this.form.getForm().get('parkingGroup');
              this.departureHotel = this.form.departureHotel || this.form.getForm().get('hotels')?.controls?.departureHotel?.value;
              this.arrivalHotel = this.form.arrivalHotel || this.form.getForm().get('hotels')?.controls?.arrivalHotel?.value;

              if (bookingDetails.orderStatus == "Cancelled") {
                this.routerNavigatePreservingParams(['/parkifly/handle-booking']);
              }
              this.orderId = bookingDetails.orderId;
              this.booking = bookingDetails;

              if (this.booking != null) {
                setTimeout(() => {
                  this.bookingLoaded = true;
                }, 1000);
              }

              this.handleBookingService.getForm().get('details').controls['cellular'].setValue(bookingDetails.cellular ?? '');
              this.handleBookingService.getForm().get('details').controls['regNr'].setValue(bookingDetails.carRegNumber ?? '');
              this.handleBookingService.getForm().get('details').controls['email'].setValue(bookingDetails.email ?? '');
              this.handleBookingService.getForm().get('details').controls['email'].disable();
              this.handleBookingService.getForm().get('details').controls['parkingSite'].setValue(bookingDetails.parking);
              this.handleBookingService.getForm().get('details').controls['parkingSite'].disable();
              if (this.booking?.arrival?.terminalName == 'Terminal 5') {
                this.booking.arrival.terminalName = 'Terminal 4'
              }
              if (this.booking?.departure?.terminalName == 'Terminal 5') {
                this.booking.departure.terminalName = 'Terminal 4'
              }
              if (this.site === 'skavsta' || this.site === 'quality hotel arlanda xpo parkering' || this.site === 'quality-xpo-arlanda' || this.site === 'quality' || this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.handleBookingService.getForm().get('details').controls['firstname'].setValue(bookingDetails.firstName ?? '');
                this.handleBookingService.getForm().get('details').controls['firstname'].disable();
                this.handleBookingService.getForm().get('details').controls['lastname'].setValue(bookingDetails.lastName ?? '');
                this.handleBookingService.getForm().get('details').controls['lastname'].disable();
                this.handleBookingService.getForm().get('details').controls['persons']?.setValue(bookingDetails?.passengers?.toString());
                this.booking.parkingShuttleFrom = bookingDetails.parkingFromActual;
                this.booking.parkingShuttleTo = bookingDetails.parkingTo;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;

                const departureDateTimeStr = this.formatToSwedishDateTime(bookingDetails?.departure?.scheduledDeparture || bookingDetails.parkingFromActual);
                this.handleBookingService.getForm().get('details').controls['departureDate'].setValue(departureDateTimeStr);

                const arrivalDateTimeStr = this.formatToSwedishDateTime(bookingDetails?.arrival?.scheduledArrival || bookingDetails.parkingTo);
                this.handleBookingService.getForm().get('details').controls['arrivalDate'].setValue(arrivalDateTimeStr);
              }
              if (this.site === 'flygets') {
                this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
                const baggageValue = bookingDetails?.arrival?.baggage || bookingDetails?.departure?.baggage;
                this.handleBookingService.getForm().get('details').controls['baggage'].setValue(baggageValue);
                this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFromActual;

                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );

                var parkingShuttleTo = new Date(bookingDetails.parkingShuttleTo);
                var parkingEndTime = (
                  parkingShuttleTo.getHours().toString().length <= 1 ? '0' + parkingShuttleTo.getHours() : parkingShuttleTo.getHours()) + ':' +
                  (parkingShuttleTo.getMinutes().toString().length <= 1 ? '0' + parkingShuttleTo.getMinutes() : parkingShuttleTo.getMinutes()
                  );

                var parkingTo = new Date(bookingDetails.parkingTo);
                var parkingEndDateTime = (
                  parkingTo.getHours().toString().length <= 1 ? '0' + parkingTo.getHours() : parkingTo.getHours()) + ':' +
                  (parkingTo.getMinutes().toString().length <= 1 ? '0' + parkingTo.getMinutes() : parkingTo.getMinutes()
                  );

                //Add conditions
                // Set departure and arrival types based on booking data
                this.handleBookingService.getForm().get('details').controls['departureType'].setValue(this.getDepartureTypeValue());
                this.handleBookingService.getForm().get('details').controls['arrivalType'].setValue(this.getArrivalTypeValue());

                // Populate arriveAtParkingOptions
                const parkingFromForTimeOptions: any = new Date(bookingDetails.parkingFrom);
                this.arriveAtParkingOptions = this.parkingRepo.createParkingStartTimeOptions(parkingFromForTimeOptions);

                var parkingTo = new Date(bookingDetails.parkingTo);
                var parkingToEndTime = (
                  parkingTo.getHours().toString().length <= 1 ? '0' + parkingTo.getHours() : parkingTo.getHours()) + ':' +
                  (parkingTo.getMinutes().toString().length <= 1 ? '0' + parkingTo.getMinutes() : parkingTo.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(parkingToEndTime);
                // this.handleBookingService.getForm().get('details').controls['departureTimeAtParking'].setValue(currentParkingTime);

                // Find matching option in arriveAtParkingOptions or set first option
                const matchingOption = this.arriveAtParkingOptions.find((option: any) => option.value === currentParkingTime);
                if (matchingOption) {
                  this.handleBookingService.getForm().get('details').controls['departureTimeAtParking'].setValue(matchingOption.value);
                } else if (this.arriveAtParkingOptions.length > 0) {
                  this.handleBookingService.getForm().get('details').controls['departureTimeAtParking'].setValue(this.arriveAtParkingOptions[0].value);
                }

                this.handleBookingService.getForm().get('details').controls['arrivalTime'].setValue(parkingEndTime);
                this.handleBookingService.getForm().get('details').controls['departureTime'].setValue(currentParkingTime);

                const departureDateObj = new Date(bookingDetails?.departure?.scheduledDeparture || bookingDetails.parkingFromActual);
                const departureDate = departureDateObj.getFullYear() + '-' +
                  String(departureDateObj.getMonth() + 1).padStart(2, '0') + '-' +
                  String(departureDateObj.getDate()).padStart(2, '0');

                const arrivalDateObj = new Date(bookingDetails?.arrival?.scheduledArrival || bookingDetails.parkingTo);
                const arrivalDate = arrivalDateObj.getFullYear() + '-' +
                  String(arrivalDateObj.getMonth() + 1).padStart(2, '0') + '-' +
                  String(arrivalDateObj.getDate()).padStart(2, '0');
                this.handleBookingService.getForm().get('details').controls['departureDate'].setValue(departureDate);
                this.handleBookingService.getForm().get('details').controls['arrivalDate'].setValue(arrivalDate);

                if (bookingDetails.departure?.departureCode == null) {
                  const parkingFromDate = new Date(bookingDetails.parkingFromActual);
                  const depDate = parkingFromDate.getFullYear() + '-' +
                    String(parkingFromDate.getMonth() + 1).padStart(2, '0') + '-' +
                    String(parkingFromDate.getDate()).padStart(2, '0');
                  const depTime = parkingFromDate.getHours().toString().padStart(2, '0') + ':' + parkingFromDate.getMinutes().toString().padStart(2, '0');
                  const depDateTimeStr = `${depDate} | ${depTime}`;
                  this.handleBookingService.getForm().get('details').controls['departureDate'].setValue(depDateTimeStr);
                }

                if (bookingDetails.arrival?.arrivalCode == null) {
                  const parkingToDate = new Date(bookingDetails.parkingTo);
                  const arrDate = parkingToDate.getFullYear() + '-' +
                    String(parkingToDate.getMonth() + 1).padStart(2, '0') + '-' +
                    String(parkingToDate.getDate()).padStart(2, '0');
                  const arrTime = parkingToDate.getHours().toString().padStart(2, '0') + ':' + parkingToDate.getMinutes().toString().padStart(2, '0');
                  const arrDateTimeStr = `${arrDate} | ${arrTime}`;
                  this.handleBookingService.getForm().get('details').controls['arrivalDate'].setValue(arrDateTimeStr);
                }

                this.handleBookingService.getForm().get('details').controls['arrivalHotel'].setValue(bookingDetails.arrival?.terminalName ?? '');
                this.handleBookingService.getForm().get('details').controls['departureHotel'].setValue(bookingDetails.departure?.terminalName ?? '');

                if (bookingDetails.departure) {
                  const depTime = new Date(bookingDetails.departure.scheduledDeparture);
                  const depTimeStr = depTime.getHours().toString().padStart(2, '0') + ':' + depTime.getMinutes().toString().padStart(2, '0');
                  const departureFlightInfo = `${bookingDetails.departure.departureCode} | ${bookingDetails.departure.arrivalStation} | ${depTimeStr}`;
                  this.handleBookingService.getForm().get('details').controls['departureFlight'].setValue(departureFlightInfo);
                }

                if (bookingDetails.arrival) {
                  const arrTime = new Date(bookingDetails.arrival.scheduledArrival);
                  const arrTimeStr = arrTime.getHours().toString().padStart(2, '0') + ':' + arrTime.getMinutes().toString().padStart(2, '0');
                  const arrivalFlightInfo = `${bookingDetails.arrival.arrivalCode} | ${bookingDetails.arrival.departureStation} | ${arrTimeStr}`;
                  this.handleBookingService.getForm().get('details').controls['arrivalFlight'].setValue(arrivalFlightInfo);
                }

                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(parkingEndDateTime);
                const additionalServicesArray = bookingDetails?.additionalServices?.length > 0
                  ? bookingDetails.additionalServices.filter((e: any) => (e.status != 'Cancelled' && e.status != 'Removed'))
                  : [];
                if (additionalServicesArray.length > 0) {
                  additionalServicesArray.forEach(function (element: any, index: any) {
                    if (typeof element.name === 'string') {
                      element.name = JSON.parse(element.name);
                    }
                    if (typeof element.description === 'string') {
                      element.description = JSON.parse(element.description);
                    }
                    if (element.amount && element.vatAmount) {
                      element.amount = element.amount + element.vatAmount;
                    }
                  });
                }
                this.bookingDetails.additionalServices = additionalServicesArray;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;

                // Store original booking details for comparison
                this.originalBookingDetails = JSON.parse(JSON.stringify({
                  additionalServices: additionalServicesArray
                }));

                //Call checkAvailableParkings API to check additional services
                // this.getAvailableParkingsForOrganization(this.booking.parkingShuttleFrom, this.booking.parkingShuttleTo, this.booking.discountCode ?? 'NONE');
              }
              this.isLoading = false;
              this.setupFieldWatchers();
            })
          }
        );
      } else {
        this.routerNavigatePreservingParams(['/parkifly/handle-booking']);
      }
    });
  }

  formatDate(sourceDate: Date): string {
    var twoDigitMonth = ((sourceDate.getMonth() + 1) >= 10) ? (sourceDate.getMonth() + 1) : '0' + (sourceDate.getMonth() + 1);
    var twoDigitDate = ((sourceDate.getDate()) >= 10) ? (sourceDate.getDate()) : '0' + (sourceDate.getDate());
    var twoDigitHour = ((sourceDate.getHours()) >= 10) ? (sourceDate.getHours()) : '0' + (sourceDate.getHours());
    var twoDigitMinute = ((sourceDate.getMinutes()) >= 10) ? (sourceDate.getMinutes()) : '0' + (sourceDate.getMinutes());
    var returnDate = sourceDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate + 'T' + twoDigitHour + ':' + twoDigitMinute + ':00';
    return returnDate;
  }

  getShuttleDate(flightDateStr: string, hasBaggage: any) {
    if (!flightDateStr) return '';

    const flightDate = /[zZ]|[+-]\d{2}:?\d{2}$/.test(flightDateStr)
      ? new Date(flightDateStr)
      : this.parseDateTimeStringAsTimeZone(flightDateStr, 'Europe/Stockholm');

    if (!flightDate || isNaN(flightDate.getTime())) {
      return '';
    }

    const minutesToAdd = (hasBaggage == 'true' || hasBaggage === 1) ? 45 : 25;
    flightDate.setMinutes(flightDate.getMinutes() + minutesToAdd);
    return this.formatDateTimeToTimeZoneIso(flightDate, 'Europe/Stockholm');
  };

  updateBooking() {
    const form = this.handleBookingService.getForm().value;
    var updates;
    this.isLoading = true;

    if (this.site === 'flygets' || this.site == 'tui' || this.site === 'nazar') {

      const arrivalFlightInfo = this.arrivalFlight;
      const departureFlightInfo = this.departureFlight;

      let departureFlightnr = departureFlightInfo ? departureFlightInfo.flightId : this.booking.departure?.departureCode ?? null;
      let departureFlightdate = departureFlightInfo?.departureTime?.scheduled
        ? (departureFlightInfo?.departureTime.scheduled)
        : (this.booking.departure?.scheduledDeparture ?? undefined);
      let departureFlightdeparturedate = departureFlightInfo ? departureFlightInfo?.flightLegIdentifier?.flightDepartureDateUtc : (this.booking.departure?.scheduledDeparture ? (this.booking.departure?.scheduledDeparture?.replace(/T.*$/, 'T00:00:00')) : null);
      let departureFlightterminal = departureFlightInfo ? departureFlightInfo.locationAndStatus?.terminal : this.booking.departure?.terminalName ?? null;

      let arrivalFlightnr = arrivalFlightInfo ? arrivalFlightInfo.flightId : this.booking.arrival?.arrivalCode ?? null;
      let arrivalFlightdate = arrivalFlightInfo?.arrivalTime?.scheduled ? (arrivalFlightInfo?.arrivalTime.scheduled) : (this.booking.arrival?.scheduledArrival ?? undefined);
      let arrivalFlightdeparturedate = arrivalFlightInfo ? arrivalFlightInfo?.flightLegIdentifier?.flightDepartureDateUtc : (this.booking.arrival?.scheduledArrival ? (this.booking.arrival?.scheduledArrival?.replace(/T.*$/, 'T00:00:00')) : null);
      let arrivalFlightterminal = arrivalFlightInfo ? arrivalFlightInfo.locationAndStatus?.terminal : this.booking.arrival?.terminalName ?? null;

      if (this.showDepHotel) {
        departureFlightnr = null;
        departureFlightdate = null;
        departureFlightdeparturedate = null;
        departureFlightterminal = null;
      }

      if (this.showArrHotel) {
        arrivalFlightnr = null;
        arrivalFlightdate = null;
        arrivalFlightdeparturedate = null;
        arrivalFlightterminal = null;
      }

      const arrivalHotel = this.handleBookingGroup.get('arrivalHotel')?.value || this.booking.arrival?.terminalName || form.hotels?.arrivalHotel;
      const departureHotel = this.handleBookingGroup.get('departureHotel')?.value || this.booking.departure?.terminalName || form.hotels?.departureHotel;

      let departureTerminal = departureHotel || departureFlightterminal;
      let arrivalTerminal = arrivalHotel || arrivalFlightterminal;

      var timeFromForm = form.details.arrivalTimeAtParking;
      var hoursFromForm = timeFromForm.charAt(0) == 0 ? timeFromForm.substring(1, 2) : timeFromForm.substring(0, 2);
      var minutesFromForm = timeFromForm.charAt(3) == 0 ? timeFromForm.substring(4) : timeFromForm.substring(3);
      var newParkingFrom = new Date(this.parkingFrom);
      newParkingFrom.setHours(hoursFromForm, minutesFromForm);

      updates = {
        orderNumber: this.bookingNumber ?? '',
        orderId: this.orderId ?? '',
        email: this.email ? this.email : '',
        customer: {
          cellular: form.details.cellular,
          comment: form.details.comment,
          contact: form.details.contact ? (form.details.contact == 'true' ? true : false) : false,
          discountCode: form.details.discount,
        },
        parking: {
          carId: form.details.regNr,
          parkingFrom: this.formattedDeparture != '' ? this.formattedDeparture : this.getParkingFromDate(form),
          parkingTo: this.formattedArrival != '' ? this.formattedArrival : this.getParkingToDate(form),
          passengers: parseInt(form.details.persons)
        },
        shuttles: [
          {
            stationcode: 'ARN',
            shuttletypecode: 'flygets-p1-airport-transfer',
            productcode: 'SHUTDEP',
            shuttledate: this.formattedDeparture != '' ? this.formattedDeparture : this.getParkingFromDate(form),
            flightnr: departureFlightnr,
            flightdate: departureFlightdate,
            flightdeparturedate: departureFlightdate?.replace(/T\d{2}:\d{2}:\d{2}/, 'T00:00:00'),
            flightterminal: departureFlightterminal,
            terminal: departureTerminal,
            passengers: form.details.persons,
            childseats: 0,
            baggage: this.handleBookingGroup.controls.baggage?.value,
            comment: form.details.comment
          },
          {
            stationcode: 'ARN',
            shuttletypecode: 'flygets-p1-parking-transfer',
            productcode: 'SHUTARR',
            shuttledate: arrivalFlightdate ? this.getShuttleDate(arrivalFlightdate, this.handleBookingGroup.controls.baggage?.value) : (this.showArrHotel ? this.handleBookingGroup.controls.arrivalDate.value?.replace(/\s*\|\s*/, 'T') + ':00' : this.formatDate(new Date(this.handleBookingGroup.controls.arrivalTimeAtParking.value))),
            flightnr: arrivalFlightnr,
            flightdate: arrivalFlightdate,
            flightdeparturedate: arrivalFlightdate?.replace(/T\d{2}:\d{2}:\d{2}/, 'T00:00:00'),
            flightterminal: arrivalFlightterminal,
            terminal: arrivalTerminal,
            passengers: form.details.persons,
            childseats: 0,
            baggage: this.handleBookingGroup.controls.baggage?.value,
            comment: form.details.comment
          }
        ]
      }
    }
    else if (this.site === 'skavsta' || this.site === 'quality-xpo-arlanda' || this.site === 'quality hotel arlanda xpo parkering' || this.site === 'quality' || this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
      updates = {
        orderNumber: this.bookingNumber ?? '',
        orderId: this.orderId ?? '',
        email: this.email ? this.email : '',
        customer: {
          orderNumber: this.bookingNumber ? this.bookingNumber : '',
          cellular: form.details.cellular,
          discountCode: form.details.discount
        },
        parking: {
          carId: form.details.regNr,
          parkingFrom: (this.handleBookingGroup.controls.departureDate.value).replace(/\s*\|\s*/, 'T') + ':00',
          parkingTo: (this.handleBookingGroup.controls.arrivalDate.value).replace(/\s*\|\s*/, 'T') + ':00',
          passengers: parseInt(form.details.persons)
        }
      }
    }

    if (this.site == "flygets" && this.bookingDetails?.additionalServices) {
      (updates as any).additionalServices = [];
    }

    this.handleBookingService.updateOrderByOrderNumberEmail(updates).subscribe(result => {
      this.isLoading = false;

      if (result.result !== 'DetailsRetrieved') {
        this._snackBar.open(result.result, 'OK', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        return;
      }

      this.formHasChanges = false;
      this.handleBookingGroup.markAsPristine();
      const message = this.translate.translate('HANDLE_BOOKING.UPDATE_BOOKING');
      this._snackBar.open(message, 'OK', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      if (this.site === 'flygets' || this.site === 'tui' || this.site === 'nazar') {
        if ((this.booking?.parkingStatus !== 'Checkin') && (this.booking?.parkingStatus !== 'Checkout')) {
          this.routerNavigatePreservingParams(['/parkifly/edit-parking-additional-services', { email: this.email, booking_number: this.bookingNumber }]);
        } else {
          if (this.additionalPaymentAmount > 0) {
            this.routerNavigatePreservingParams(['parkifly', this.site, 'checkout', 'payment', this.orderId]);
          } else {
            this.routerNavigatePreservingParams(['/parkifly/booking-overview', { email: this.email, booking_number: this.bookingNumber }]);
          }
        }
      } else {
        if (this.additionalPaymentAmount > 0) {
          this.routerNavigatePreservingParams(['parkifly', this.site, 'checkout', 'payment', this.orderId]);
        } else {
          this.routerNavigatePreservingParams(['/parkifly/booking-overview', { email: this.email, booking_number: this.bookingNumber }]);
        }
      }
    });
  }

  private getPreservedQueryParams(): Record<string, string> {
    const params = this.route.snapshot.queryParamMap;
    const queryParams: Record<string, string> = {};
    const lang = params.get('lang');
    const mobile = params.get('mobile');

    if (lang) {
      queryParams.lang = lang;
    }
    if (mobile) {
      queryParams.mobile = mobile;
    }

    this.hasSpecialParams = !!(lang || mobile);

    return queryParams;
  }

  private routerNavigatePreservingParams(commands: any[], extras: NavigationExtras = {}) {
    const preserved = this.getPreservedQueryParams();
    const mergedQueryParams = {
      ...(extras.queryParams || {}),
      ...preserved
    };

    if (Object.keys(mergedQueryParams).length > 0) {
      extras = { ...extras, queryParams: mergedQueryParams };
    }

    this.router.navigate(commands, extras);
  }

  regToUpper() {
    this.handleBookingGroup.controls["regNr"].setValue(this.handleBookingGroup.controls["regNr"]._pendingValue.toUpperCase());
  }

  goToPaymentPage() {
    this.routerNavigatePreservingParams(['parkifly', this.site, 'checkout', 'payment', this.orderId]);
  }

  goBack() {
    this.routerNavigatePreservingParams(['parkifly/booking-overview', { email: this.email, booking_number: this.bookingNumber }]);
  }

  openDatepicker(field: string) {
    if (this.dialog.openDialogs.length > 0) {
      return;
    }
    if (!this.checkServicesBeforeFieldChange()) {
      return;
    }

    const currentDate = this.handleBookingGroup.controls[field]?.value || new Date();
    const dialogRef = this.dialog.open(DatePickerModalComponent, {
      width: '400px',
      data: { selectedDate: currentDate, timeSelector: false }
    });

    const componentInstance = dialogRef.componentInstance;
    componentInstance.dateSelectEvent.subscribe((selectedDate: Date) => {
      const year = selectedDate.getFullYear();
      const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
      const day = selectedDate.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      const control = this.handleBookingService.getForm().get('details').controls[field];
      control.setValue(formattedDate);
      control.markAsDirty();
      control.updateValueAndValidity();
      dialogRef.close();

      if (field === 'departureDate') {
        this.handleBookingService.getForm().get('details').controls['departureFlight'].setValue('');
        this.handleBookingService.getForm().get('details').controls['departureTimeAtParking'].setValue('');
        const flightControl = this.handleBookingService.getForm().get('details').controls['departureFlight'];
        const timeControl = this.handleBookingService.getForm().get('details').controls['departureTimeAtParking'];
        flightControl.markAsDirty();
        flightControl.markAsTouched();
        flightControl.updateValueAndValidity();
        timeControl.markAsDirty();
        timeControl.markAsTouched();
        timeControl.updateValueAndValidity();

        this.resetArrivalFieldsIfDepartureDateAfterArrival();
      }

      if (field === 'arrivalDate') {
        this.handleBookingService.getForm().get('details').controls['arrivalFlight'].setValue('');
        this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue('');
        const flightControl = this.handleBookingService.getForm().get('details').controls['arrivalFlight'];
        const timeControl = this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'];
        flightControl.markAsDirty();
        flightControl.markAsTouched();
        flightControl.updateValueAndValidity();
        timeControl.markAsDirty();
        timeControl.markAsTouched();
        timeControl.updateValueAndValidity();

        this.resetDepartureFieldsIfArrivalDateBeforeDeparture();
      }

    });
  }

  openFlightDialog(type: string, dateType: string, field: string) {
    if (this.dialog.openDialogs.length > 0) {
      return;
    }
    if (!this.checkServicesBeforeFieldChange()) {
      return;
    }

    const dialogRef = this.dialog.open(FlightPickerModalComponent, {
      panelClass: 'pf-dateflight-picker-dialog',
      data: {
        selectedDate: this.handleBookingGroup.controls[dateType]?.value,
        type: type,
      }
    });

    dialogRef.componentInstance.selectFlightEvent.subscribe((flight) => {
      const flightId = flight.flightId;
      const flightAirport = type == 'departure' ? flight.arrivalAirportEnglish : flight.departureAirportEnglish;
      const flightTime = type == 'departure' ? new Date(flight.departureTime?.scheduled) : new Date(flight.arrivalTime?.scheduled);
      const flightTimeStr = flightTime.getHours().toString().padStart(2, '0') + ':' + flightTime.getMinutes().toString().padStart(2, '0');
      const flightInfo = `${flightId} | ${flightAirport} | ${flightTimeStr}`;

      // Set the selected flight into the form and mark it dirty/touched so
      // checkFormChanges() will pick up the change.
      const detailsForm = this.handleBookingService.getForm().get('details');
      const control = detailsForm.controls[field];
      control.setValue(flightInfo);
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();

      if (!this.showDepHotel && type == 'departure') {
        this.departureFlight = flight;
        this.arriveAtParkingOptions = this.parkingRepo.createParkingStartTimeOptions(flight.departureTime?.scheduled);
        const depTimeControl = detailsForm.controls['departureTimeAtParking'];
        depTimeControl.setValue('');
        depTimeControl.markAsDirty();
        depTimeControl.markAsTouched();
        depTimeControl.updateValueAndValidity();
      }
      if (!this.showArrHotel && type == 'arrival') {
        this.arrivalFlight = flight;
        const adjustedFlightTime = new Date(flightTime);
        adjustedFlightTime.setHours(adjustedFlightTime.getHours() + 1);
        const flightTimeStr =
          adjustedFlightTime.getHours().toString().padStart(2, '0') + ':' +
          adjustedFlightTime.getMinutes().toString().padStart(2, '0');
        const arrTimeControl = detailsForm.controls['arrivalTimeAtParking'];
        arrTimeControl.setValue(flightTimeStr);
        arrTimeControl.markAsDirty();
        arrTimeControl.markAsTouched();
        arrTimeControl.updateValueAndValidity();
      }
    });

  }

  getDepartureTypeValue(): string {
    this.showDepHotel = this.booking?.departure?.departureCode ? false : true;
    return this.booking?.departure?.departureCode ? 'true' : 'false';
  }

  getArrivalTypeValue(): string {
    this.showArrHotel = this.booking?.arrival?.arrivalCode ? false : true;
    return this.booking?.arrival?.arrivalCode ? 'true' : 'false';
  }

  onArrivalTypeChange(formControl: any) {
    if (!this.checkServicesBeforeFieldChange()) {
      return;
    }

    this.showArrHotel = formControl.value === 'false';

    // Clear fields when switching types
    if (formControl.value === 'true') {
      // Switching to flight
      this.handleBookingService.getForm().get('details').controls['arrivalDate'].setValue('');
      this.handleBookingService.getForm().get('details').controls['arrivalFlight'].setValue('');
      this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue('');
    } else {
      // Switching to hotel
      this.handleBookingService.getForm().get('details').controls['arrivalDate'].setValue('');
      this.handleBookingService.getForm().get('details').controls['arrivalHotel'].setValue('');
    }
  }

  onDepartureTypeChange(formControl: any) {
    if (!this.checkServicesBeforeFieldChange()) {
      return;
    }

    this.showDepHotel = formControl.value === 'false';

    // Clear fields when switching types
    if (formControl.value === 'true') {
      // Switching to flight
      this.handleBookingService.getForm().get('details').controls['departureDate'].setValue('');
      this.handleBookingService.getForm().get('details').controls['departureFlight'].setValue('');
      this.handleBookingService.getForm().get('details').controls['departureTimeAtParking'].setValue('');
    } else {
      // Switching to hotel
      this.handleBookingService.getForm().get('details').controls['departureDate'].setValue('');
      this.handleBookingService.getForm().get('details').controls['departureHotel'].setValue('');
    }
  }

  getHotelSelectOptions() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let hostPath = JSON.parse(this.bookingConfigService.getConfig().IDENTITY);
    const URL = `${hostPath}Shuttlebuss/Shuttlebuss.Service/ArrivalDeparture/terminals/59D90114-9889-474E-A8A8-D1926F0DEE70`;
    return this.http
      .get<any>(URL, { headers })
      .pipe(map((hotelOptions: any) => {
        return hotelOptions
      }),
        catchError(
          this.handleError
        )
      );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(`handleBookingService.handleError ${errMsg}`);
    return throwError(error);
  }

  generateTimeOptions() {
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const timeStr = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        this.timeOptions.push({ value: timeStr, viewValue: timeStr });
      }
    }
  }

  openDatetimePicker(field: string) {
    if (this.dialog.openDialogs.length > 0) {
      return;
    }
    if (!this.checkServicesBeforeFieldChange()) {
      return;
    }

    const currentValue = this.handleBookingGroup.controls[field]?.value.replace(' | ', 'T') + ':00';
    const dialogRef = this.dialog.open(ModalSimpleDatetimeComponent, {
      width: '400px',
      data: {
        selectedDate: currentValue ? new Date(currentValue) : new Date(),
        type: field,
        minDate: new Date()
      }
    });

    dialogRef.componentInstance.selectDatetimeEvent.subscribe((result: any) => {
      if ((field === 'departureDate' || field === 'arrivalDate')) {
        const year = result.datetime.getFullYear();
        const month = (result.datetime.getMonth() + 1).toString().padStart(2, '0');
        const day = result.datetime.getDate().toString().padStart(2, '0');
        const date = `${year}-${month}-${day}`;
        const time = result.datetime.getHours().toString().padStart(2, '0') + ':' + result.datetime.getMinutes().toString().padStart(2, '0');
        const dateTimeStr = `${date} | ${time}`;
        const control = this.handleBookingService.getForm().get('details').controls[field];
        control.setValue(dateTimeStr);
        control.markAsDirty();
        control.markAsTouched();
        control.updateValueAndValidity();
        if (field === 'arrivalDate') {
          this.resetDepartureFieldsIfArrivalDateBeforeDeparture();
        }
        if (field === 'departureDate') {
          this.resetArrivalFieldsIfDepartureDateAfterArrival();
        }
      } else {
        const timeStr = result.datetime.getHours().toString().padStart(2, '0') + ':' + result.datetime.getMinutes().toString().padStart(2, '0');
        const control = this.handleBookingService.getForm().get('details').controls[field];
        control.setValue(timeStr);
        control.markAsDirty();
        control.markAsTouched();
        control.updateValueAndValidity();
      }
    });
  }

  convertDateTimeFormat(dateTimeStr: string) {
    if (!dateTimeStr) return '';
    const parts = dateTimeStr?.split(' | ');
    if (!parts || parts.length !== 2) return '';
    const [date, time] = parts;
    const timeParts = time?.split(':');
    if (!timeParts || timeParts.length !== 2) return '';
    const [hours, minutes] = timeParts;
    return `${date}T${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
  }

  private formatDateTimeToLocalIso(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}T${hh}:${min}:00`;
  }

  convertDateTimeFormatForFlight(dateStr: string, timeStr: string, options?: any[]) {
    if (!dateStr || !timeStr) return '';

    const selectedOption = options?.find(option => option?.value === timeStr);
    if (selectedOption?.datetime) {
      return this.formatDateTimeToLocalIso(new Date(selectedOption.datetime));
    }

    const timeParts = timeStr.split(':');
    if (timeParts.length !== 2) return '';
    const [hours, minutes] = timeParts;
    return `${dateStr}T${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
  }

  private formatDateTimeToTimeZoneIso(date: Date, timeZone: string): string {
    const fmt = new Intl.DateTimeFormat('sv-SE', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    const parts = fmt.formatToParts(date);
    const year = parts.find(p => p.type === 'year')?.value;
    const month = parts.find(p => p.type === 'month')?.value;
    const day = parts.find(p => p.type === 'day')?.value;
    const hour = parts.find(p => p.type === 'hour')?.value;
    const minute = parts.find(p => p.type === 'minute')?.value;

    if (!year || !month || !day || !hour || !minute) {
      return this.formatDateTimeToLocalIso(date);
    }

    return `${year}-${month}-${day}T${hour}:${minute}:00`;
  }

  private parseDateTimeStringAsTimeZone(dateTimeStr: string, timeZone: string): Date | null {
    if (!dateTimeStr) {
      return null;
    }

    const normalized = dateTimeStr.replace(/\.\d+$/, '');
    const [datePart, timePart] = normalized.split('T');
    if (!datePart || !timePart) {
      return null;
    }

    const [year, month, day] = datePart.split('-').map(part => parseInt(part, 10));
    const [hour = '0', minute = '0', secondPart = '0'] = timePart.split(':');
    const second = parseInt(secondPart.split('.')[0], 10);
    if ([year, month, day, parseInt(hour, 10), parseInt(minute, 10), second].some(Number.isNaN)) {
      return null;
    }

    const utcCandidate = Date.UTC(year, month - 1, day, parseInt(hour, 10), parseInt(minute, 10), second);
    const fmt = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    const parts = fmt.formatToParts(new Date(utcCandidate));
    const zoneYear = parseInt(parts.find(p => p.type === 'year')?.value || '', 10);
    const zoneMonth = parseInt(parts.find(p => p.type === 'month')?.value || '', 10);
    const zoneDay = parseInt(parts.find(p => p.type === 'day')?.value || '', 10);
    const zoneHour = parseInt(parts.find(p => p.type === 'hour')?.value || '', 10);
    const zoneMinute = parseInt(parts.find(p => p.type === 'minute')?.value || '', 10);
    const zoneSecond = parseInt(parts.find(p => p.type === 'second')?.value || '', 10);
    if ([zoneYear, zoneMonth, zoneDay, zoneHour, zoneMinute, zoneSecond].some(Number.isNaN)) {
      return null;
    }

    const zoneTimestamp = Date.UTC(zoneYear, zoneMonth - 1, zoneDay, zoneHour, zoneMinute, zoneSecond);
    const offsetMs = utcCandidate - zoneTimestamp;
    return new Date(utcCandidate + offsetMs);
  }

  private convertScheduledArrivalToLocalIsoPlusOneHour(flightDateStr: string): string {
    if (!flightDateStr) {
      return '';
    }

    let parsedDate: Date | null;
    if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(flightDateStr.trim())) {
      parsedDate = new Date(flightDateStr);
    } else {
      parsedDate = this.parseDateTimeStringAsTimeZone(flightDateStr, 'Europe/Stockholm');
    }

    if (!parsedDate || isNaN(parsedDate.getTime())) {
      return '';
    }

    const added = new Date(parsedDate.getTime() + 60 * 60 * 1000);
    return this.formatDateTimeToTimeZoneIso(added, 'Europe/Stockholm');
  }

  private parseControlDate(value: string): Date | null {
    if (!value) {
      return null;
    }

    const normalized = value.includes(' | ') ? value.replace(' | ', 'T') + ':00' : value;
    const parsed = new Date(normalized);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  private resetDepartureFieldsIfArrivalDateBeforeDeparture() {
    const details = this.handleBookingService.getForm().get('details').controls;
    const arrivalValue = details['arrivalDate']?.value;
    const departureValue = details['departureDate']?.value;
    if (!arrivalValue || !departureValue) {
      return;
    }

    const arrivalDate = this.parseControlDate(arrivalValue);
    const departureDate = this.parseControlDate(departureValue);
    if (!arrivalDate || !departureDate) {
      return;
    }

    if (arrivalDate < departureDate) {
      details['departureDate'].setValue('');
      details['departureFlight'].setValue('');
      details['departureTimeAtParking'].setValue('');
      details['departureHotel'].setValue('');

      ['departureDate', 'departureFlight', 'departureTimeAtParking', 'departureHotel'].forEach(field => {
        const control = details[field];
        if (control) {
          control.markAsDirty();
          control.markAsTouched();
          control.updateValueAndValidity();
        }
      });
    }
  }

  private resetArrivalFieldsIfDepartureDateAfterArrival() {
    const details = this.handleBookingService.getForm().get('details').controls;
    const arrivalValue = details['arrivalDate']?.value;
    const departureValue = details['departureDate']?.value;
    if (!arrivalValue || !departureValue) {
      return;
    }

    const arrivalDate = this.parseControlDate(arrivalValue);
    const departureDate = this.parseControlDate(departureValue);
    if (!arrivalDate || !departureDate) {
      return;
    }

    if (departureDate > arrivalDate) {
      details['arrivalDate'].setValue('');
      details['arrivalFlight'].setValue('');
      details['arrivalTimeAtParking'].setValue('');
      details['arrivalHotel'].setValue('');

      ['arrivalDate', 'arrivalFlight', 'arrivalTimeAtParking', 'arrivalHotel'].forEach(field => {
        const control = details[field];
        if (control) {
          control.markAsDirty();
          control.markAsTouched();
          control.updateValueAndValidity();
        }
      });
    }
  }

  calculateParking() {
    const departureDate = this.handleBookingService.getForm().get('details').controls['departureDate'].value;
    const arrivalDate = this.handleBookingService.getForm().get('details').controls['arrivalDate'].value;

    const departureTimeAtParking = this.handleBookingService.getForm().get('details')?.controls['departureTimeAtParking']?.value;
    const arrivalTimeAtParking = this.handleBookingService.getForm().get('details')?.controls['arrivalTimeAtParking']?.value;

    let formattedArrival = '';
    let formattedDeparture = '';
    let discountCode = this.booking?.discountCode != null ? this.booking?.discountCode : 'NONE'

    if (this.showArrHotel || !this.advancedBooking) {
      formattedArrival = this.convertDateTimeFormat(arrivalDate);
    } else {
      // If arrival is a flight selection, prefer the flight's scheduled arrival datetime
      const arrivalType = this.handleBookingGroup.controls['arrivalType']?.value;
      if (arrivalType === 'true') {
        const flightDateStr = this.arrivalFlight?.arrivalTime?.scheduled ?? this.booking.arrival?.scheduledArrival;
        if (flightDateStr) {
          formattedArrival = this.convertScheduledArrivalToLocalIsoPlusOneHour(flightDateStr);
        } else {
          // fallback to time+date combine if no scheduled value available
          formattedArrival = this.convertDateTimeFormatForFlight(arrivalDate, arrivalTimeAtParking);
        }
      } else {
        formattedArrival = this.convertDateTimeFormatForFlight(arrivalDate, arrivalTimeAtParking);
      }
    }

    if (this.showDepHotel || !this.advancedBooking) {
      formattedDeparture = this.convertDateTimeFormat(departureDate);
    } else {
      formattedDeparture = this.convertDateTimeFormatForFlight(departureDate, departureTimeAtParking, this.arriveAtParkingOptions);
    }

    // Only call API if both dates are valid
    if (formattedDeparture && formattedArrival) {
      this.formattedDeparture = formattedDeparture;
      this.formattedArrival = formattedArrival;
      this.getAvailableParkingsForOrganization(formattedDeparture, formattedArrival, discountCode);
    }

  }

  getAvailableParkingsForOrganization(periodFrom: string, periodTo: string, discountCode: string) {
    this.isLoadingParkings = true;
    this.showRetryButton = false;
    this.lastApiParams = { periodFrom, periodTo, discountCode };
    const message = this.translate.translate('HANDLE_BOOKING.CHECK_AVAILABLE_PARKING');
    this._snackBar.open(message, undefined, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
    this.cartService
      .getAvailableParkingsOnEdit(this.orderId, periodFrom, periodTo, discountCode)
      .pipe(
        timeout(30000),
        catchError(error => {
          this.isLoadingParkings = false;
          setTimeout(() => {
            this.showRetryButton = true;
          }, 0);
          console.error('API call failed:', error);
          this.parkings = this.parkings || [];
          return of(null);
        })
      )
      .subscribe((parkings: any) => {
        this.isLoadingParkings = false;
        this.showRetryButton = false;

        this.parkingOutOfOrder = !parkings?.parkings;
        if (this.parkingOutOfOrder) {
          this.parkings = [];
          this.selectedParking.next(null);
          this.additionalPaymentAmount = 0;
          return;
        }

        if (this.booking?.organizationName?.toLocaleLowerCase() == 'tui' || this.booking?.organizationName?.toLocaleLowerCase() == 'nazar') {
          this.parkings = parkings?.parkings.filter((parking: any) => {
            return parking.id == '8c98315a-b2ad-4e70-86f9-5d54992fed26';
          })
        } else {
          this.parkings = parkings?.parkings?.reverse();
        }

        if (this.booking?.parkingProductType == 'Subscription') {
          this.parkings = parkings?.parkings?.filter((parking: any) => parking.subscriptionParking == true);
        } else {
          this.parkings = parkings?.parkings?.filter((parking: any) => parking.subscriptionParking == false);
        }

        if (this.tentantConfigSortingParking[this.booking?.organizationName?.toLowerCase()]) {
          this.parkings = this.tentantConfigSortingParking[this.booking?.organizationName?.toLowerCase()](this.parkings);
        }

        const parkingSite: any = this.booking?.parking?.toLowerCase();
        const parking: any = parkings?.parkings?.filter((parking: any) => parking?.name?.toLowerCase() == parkingSite);
        this.additionalServicesFromOrder = (parking && parking[0]?.additionalServices) || [];

        // Set price comparison values
        if (parking[0]) {
          this.selectedParking.next(parking[0]);
          if (this.booking?.totalDiscountPriceIncVat) {
            this.previousPrice = this.booking.totalDiscountPriceIncVat;
          } else {
            this.previousPrice = this.booking.totalPriceIncVat;
          }

          if (parking[0]?.discountTotalPrice) {
            this.currentPrice = parking[0]?.discountTotalPrice;
          } else {
            this.currentPrice = parking[0].totalPrice;
          }

          if (this.bookingDetails.additionalServices?.length > 0) {
            this.bookingDetails.additionalServices?.forEach((service: any) => {
              this.currentPrice += (service.totalPrice || 0);
            })
          }

          if (this.bookingDetails.additionalProducts?.length > 0) {
            this.bookingDetails.additionalProducts?.forEach((product: any) => {
              this.currentPrice += ((product.amount + product.vatAmount) * product.quantity);
            })
          }

          const amount = (Number(parking[0]?.additionalPaymentAmount || 0)) * 1.25;
          this.additionalPaymentAmount = isNaN(amount) ? 0 : Number(amount.toFixed(2));
        }

      });
  }

  retryParkingAvailability() {
    if (this.lastApiParams) {
      this.getAvailableParkingsForOrganization(
        this.lastApiParams.periodFrom,
        this.lastApiParams.periodTo,
        this.lastApiParams.discountCode
      );
    }
  }

  get isParkingMoreThan24HoursAway(): boolean {
    const raw = this.handleBookingGroup?.controls?.departureDate?.value;
    if (!raw) return false;
    const parsed = new Date(raw.replace(/\s*\|\s*/, 'T'));
    return (parsed.getTime() - Date.now()) > 24 * 60 * 60 * 1000;
  }

  getParkingFromDate(form: any): string {
    const departureType = this.handleBookingGroup.controls['departureType']?.value;

    if (departureType === 'true') {
      // Flight scenario - use selected parking option datetime when available
      const flightDate = this.departureFlight?.departureTime?.scheduled ? this.departureFlight?.departureTime?.scheduled : this.booking.departure?.scheduledDeparture;
      const timeAtParking = form.details.departureTimeAtParking ? form.details.departureTimeAtParking : (this.bookingDetails?.parkingShuttleFrom ? this.bookingDetails.parkingShuttleFrom : '');
      if (flightDate && timeAtParking) {
        const selectedOption = this.arriveAtParkingOptions.find((option: any) => option?.value === timeAtParking);
        if (selectedOption?.datetime) {
          return this.formatDateTimeToLocalIso(new Date(selectedOption.datetime));
        }
        const date = new Date(flightDate).toISOString().split('T')[0];
        return `${date}T${timeAtParking}:00`;
      }
    }

    // Hotel scenario - use handleBookingGroup date
    return (this.handleBookingGroup.controls.departureDate.value).replace(' | ', 'T') + ':00';
    // return new Date(this.handleBookingGroup.controls.departureDate.value).toISOString().slice(0, 19);
  }

  getParkingToDate(form: any): string {
    const arrivalType = this.handleBookingGroup.controls['arrivalType']?.value;
    if (arrivalType === 'true') {
      // Flight scenario - use the flight's scheduled arrival datetime (exact date+time)
      const flightDateStr = this.arrivalFlight?.arrivalTime?.scheduled ? this.arrivalFlight?.arrivalTime?.scheduled : this.booking.arrival?.scheduledArrival;
      if (flightDateStr) {
        return this.convertScheduledArrivalToLocalIsoPlusOneHour(flightDateStr);
      }
    }

    // Hotel scenario - use handleBookingGroup date
    return (this.handleBookingGroup.controls.arrivalDate.value).replace(' | ', 'T') + ':00';
    // return new Date(this.handleBookingGroup.controls.arrivalDate.value).toISOString().slice(0, 19);
  }

  setupFieldWatchers() {
    // Clear existing subscriptions
    this.fieldSubscriptions.forEach(sub => sub.unsubscribe());
    this.fieldSubscriptions = [];

    if (this.advancedBooking) {
      // Advanced booking (flygets, etc.)
      const arrivalTypeControl = this.handleBookingGroup.controls['arrivalType'];
      const departureTypeControl = this.handleBookingGroup.controls['departureType'];

      // Watch radio buttons to re-setup watchers (no API call)
      const arrivalSub = arrivalTypeControl?.valueChanges.subscribe(() => {
        if (!this.isInitializing) {
          this.setupFieldWatchers();
        }
      });
      if (arrivalSub) this.fieldSubscriptions.push(arrivalSub);

      const departureSub = departureTypeControl?.valueChanges.subscribe(() => {
        if (!this.isInitializing) {
          this.setupFieldWatchers();
        }
      });
      if (departureSub) this.fieldSubscriptions.push(departureSub);

      // Get current values and setup field watchers
      const arrivalType = arrivalTypeControl?.value || this.getArrivalTypeValue();
      const departureType = departureTypeControl?.value || this.getDepartureTypeValue();

      let fieldsToWatch: string[] = [];

      // For arrival: flight ('true') = arrivalTimeAtParking, hotel ('false') = arrivalDate + arrivalHotel
      if (arrivalType === 'true') {
        fieldsToWatch.push('arrivalTimeAtParking');
      } else {
        fieldsToWatch.push('arrivalDate', 'arrivalHotel');
      }

      // For departure: flight ('true') = departureTimeAtParking, hotel ('false') = departureDate + departureHotel
      if (departureType === 'true') {
        fieldsToWatch.push('departureTimeAtParking');
      } else {
        fieldsToWatch.push('departureDate', 'departureHotel');
      }

      fieldsToWatch.forEach(field => {
        const fieldSub = this.handleBookingGroup.controls[field]?.valueChanges.subscribe(() => {
          if (!this.isInitializing) {
            this.handleDateFieldChange();
          }
        });
        if (fieldSub) this.fieldSubscriptions.push(fieldSub);
      });
    } else {
      // Simple booking (skavsta)
      const fieldsToWatch = ['departureDate', 'arrivalDate'];
      fieldsToWatch.forEach(field => {
        const fieldSub = this.handleBookingGroup.controls[field]?.valueChanges.subscribe(() => {
          if (!this.isInitializing) {
            this.handleDateFieldChange();
          }
        });
        if (fieldSub) this.fieldSubscriptions.push(fieldSub);
      });
    }
  }

  onDiscountBlur() {
    if (!this.isInitializing) {
      this.calculateParking();
    }
  }

  handleDateFieldChange() {
    // Check parking period before making API call
    if (this.bookingDetails?.additionalServices?.length > 0) {
      const currentDays = this.getDateDifference();
      const originalDays = this.getOriginalDateDifference();

      // If reducing parking period, clear existing services
      if (currentDays < originalDays) {
        this.bookingDetails.additionalServices = [];
      }
    }

    this.calculateParking();
  }

  onAdditionalServicesChanged(): void {
    if (this.parkings && this.parkings[0]) {
      this.updateCurrentPrice(this.parkings[0]);
    }
    this.checkFormChanges();
  }

  private checkFormChanges(): void {
    if (this.isInitializing) {
      return;
    }

    // Check if additional services have changed
    const hasAdditionalServicesChanged = this.hasAdditionalServicesChanged();

    // Set formHasChanges to true if either form fields or additional services changed
    this.formHasChanges = hasAdditionalServicesChanged || this.handleBookingGroup?.dirty || false;
  }

  private hasAdditionalServicesChanged(): boolean {
    if (!this.originalBookingDetails) {
      return false;
    }

    const original = this.originalBookingDetails.additionalServices || [];
    const current = this.bookingDetails?.additionalServices || [];

    if (original.length !== current.length) {
      return true;
    }

    return original.some((orig: any) => {
      return !current.some((curr: any) => curr.id === orig.id);
    });
  }

  checkServicesBeforeFieldChange(): boolean {
    // Show validation message if user has services
    if (this.bookingDetails?.additionalServices?.length > 0) {
      const message = this.translate.translate('HANDLE_BOOKING.CANCEL_SERVICES_TEXT');
      this._snackBar.open(message, 'OK', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });

      // Scroll to services section
      setTimeout(() => {
        const servicesSection = document.querySelector('.additional-services-section');
        if (servicesSection) {
          servicesSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
    return true;
  }

  getOriginalDateDifference(): number {
    if (!this.booking?.parkingFromActual || !this.booking?.parkingTo) {
      return 0;
    }

    const originalArrival = new Date(this.booking.parkingTo);
    const originalDeparture = new Date(this.booking.parkingFromActual);

    const timeDiff = originalArrival.getTime() - originalDeparture.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return timeDiff;
  }

  updateCurrentPrice(parking: any) {
    let basePrice = parking?.discountTotalPrice || parking.totalPrice || 0;

    if (this.bookingDetails.additionalServices?.length > 0) {
      this.bookingDetails.additionalServices.forEach((service: any) => {
        if (service.totalPrice != null) {
          basePrice += service.totalPrice;
        } else if (service.amount != null) {
          basePrice += service.amount;
        }
      });
    }

    if (this.bookingDetails.additionalProducts?.length > 0) {
      this.bookingDetails.additionalProducts?.forEach((product: any) => {
        basePrice += ((product.amount + product.vatAmount) * product.quantity);
      });
    }

    this.currentPrice = basePrice;
    if (this.previousPrice == this.currentPrice) {
      this.showPriceComparison = false;
    } else {
      this.showPriceComparison = true;
    }
  }

  // openConfirmModal() {
  //   const text = this.booking?.parkingCannotBeCanceledText;
  //   const org = this.booking?.organizationName;
  //   const dialogRef = this.dialog.open(ConfirmModalComponent, { data: { text: text, org: org } });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.cancelOrder();
  //     }
  //   });
  // }

  cancelOrder() {
    this.handleBookingService.cancelByOrderNumberEmail(
      this.bookingNumber ? this.bookingNumber : '',
      this.email ? this.email : '',
    ).then((model) => {
      if (model.result != "CanceledOrder") {
        const message = this.translate.translate('HANDLE_BOOKING.CANCEL_PARKING_FAILED');
        this._snackBar.open(message, 'OK',
          {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
      }
      if (model.result == "CanceledOrder") {
        const message = this.translate.translate('HANDLE_BOOKING.CANCEL_PARKING_SUCCESS');
        this._snackBar.open(message, 'OK', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        if (this.site?.toLowerCase() === 'flygets' || this.site?.toLowerCase() === 'skavsta') {
          this.routerNavigatePreservingParams(['/parkifly', this.site]);
        } else if (this.site === 'quality-xpo-arlanda' || this.site === 'quality hotel arlanda xpo parkering' || this.site === 'quality') {
          const preserved = this.getPreservedQueryParams();
          const extras: NavigationExtras = { queryParams: { public: 'true', ...preserved } };
          this.router.navigate(['/parkifly/quality-landing-page'], extras);
        } else if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
          const preserved = this.getPreservedQueryParams();
          const extras: NavigationExtras = { queryParams: { public: 'true', ...preserved } };
          this.router.navigate(['/parkifly/aiden-landing-page'], extras);
        } else {
          this.routerNavigatePreservingParams(['/admin/admin-start']);
        }
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  getDateDifference(): number {
    const arrivalDate = this.handleBookingGroup?.controls?.arrivalDate?.value;
    const departureDate = this.handleBookingGroup?.controls?.departureDate?.value;

    if (!arrivalDate || !departureDate) {
      return 0;
    }

    let arrivalDateTime: Date;
    let departureDateTime: Date;

    // Handle different date formats
    if (arrivalDate.includes(' | ')) {
      // Format: "2024-01-15 | 14:30"
      arrivalDateTime = new Date(arrivalDate.replace(' | ', 'T') + ':00');
    } else {
      // Format: "2024-01-15"
      arrivalDateTime = new Date(arrivalDate);
    }

    if (departureDate.includes(' | ')) {
      // Format: "2024-01-15 | 14:30"
      departureDateTime = new Date(departureDate.replace(' | ', 'T') + ':00');
    } else {
      // Format: "2024-01-15"
      departureDateTime = new Date(departureDate);
    }

    const timeDiff = arrivalDateTime.getTime() - departureDateTime.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return timeDiff;
  }

  formatToSwedishDateTime(source: string): string {
    const utcSource =
      source.endsWith('Z') || source.includes('+')
        ? source
        : source + 'Z';

    const utcDate = new Date(utcSource);

    const cetMillis = utcDate.getTime();
    const cetDate = new Date(cetMillis);

    const yyyy = cetDate.getUTCFullYear();
    const mm = String(cetDate.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(cetDate.getUTCDate()).padStart(2, '0');
    const hh = String(cetDate.getUTCHours()).padStart(2, '0');
    const min = String(cetDate.getUTCMinutes()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd} | ${hh}:${min}`;
  }

  openTermsModal() {
    this.dialog.open(TermsModal, {
      maxHeight: '85vh',
      panelClass: 'terms-modal-dialog'
    });
  }

}

@Component({
  selector: 'terms-modal',
  templateUrl: '../../../organizations/features/booking/components/form/details/terms-modal.html',
  styleUrls: ['../../../organizations/features/booking/components/form/details/modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, MatDialogContent, TranslocoModule, MatDialogActions, MatDialogClose, TermsAndConditionsComponent]
})
export class TermsModal {
  constructor() { }
}